import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../models/backofficeConfiguration';
import { ExecuteService } from './executeService.service';
import { ErrorHandlerService } from './errorHandler.service';
import { Author, AuthorMini } from '../models/Author';
import { CacheService } from './cache.service';

@Injectable()
export class AuthorService {
  private authorApiURL = APP_SETTINGS.AuthorApiUrl;

  constructor(private executeService: ExecuteService,
    private cacheService: CacheService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetAuthors(): Observable<Author[]> {
    const url = `${this.authorApiURL}api/v1/authorManager/getByFilterInvariantCulture`;

    return this.cacheService.get('getAuthors', this.executeService.Execute('get', url)
      .pipe(
        map(response => this.mapAuthorModels(response)),
        catchError(this.errorHandler.handleError<object[]>('AuthorService_GetAuthors', []))
      ));
  }

  public GetAuthorMiniById(authorId: string): Observable<AuthorMini> {
    const url = `${this.authorApiURL}/v2/en-US/authorManager/filtermini/${authorId}`;

    return this.executeService.ExecuteWithApiToken('get', url)
      .pipe(
        map(response => this.mapAuthorModel(response)),
        catchError(this.errorHandler.handleError<Author>('AuthorService_GetAuthorById'))
      );
  }

  public GetAuthorById(authorId: string): Observable<Author> {
    const url = `${this.authorApiURL}/v2/en-US/authorManager/filtermini/${authorId}`;

    return this.executeService.ExecuteWithApiToken('get', url)
      .pipe(
        map(response => this.mapAuthorModel(response)),
        catchError(this.errorHandler.handleError<Author>('AuthorService_GetAuthorById'))
      );
  }

  public GetAuthorsByContentType(contentTypeId: number): Observable<Author[]> {
    const url = `${this.authorApiURL}/v2/en-US/authorManager/allowedAuthors?isManager=true&contentTypeId=${contentTypeId}`;

    return this.cacheService.get('getAuthorsByContentType', this.executeService.Execute('get', url)
      .pipe(
        map(response => this.mapAuthorModels(response)),
        catchError(this.errorHandler.handleError<object[]>('AuthorService_GetAuthorsByContentType', []))
      ));
  }

  mapAuthorModels(authors: any): any {
    let response: Author[] = [];
    if (authors != null) {
      response = authors.map(author => ({
        AuthorId: author.Id,
        Name: author.Name,
        UserId: author.UserId
      }));
    }
    return response;
  }

  mapAuthorModel(author: any): any {
    let response: Author = null;
    if (author != null) {
      response = {
        AuthorId: author.Id,
        Name: author.Name,
        UserId: author.UserId,
        Url: author.Url,
        UrlPhoto: author.UrlPhoto
      };
    }
    return response;
  }

  authorMiniToAuthor(authorMini: AuthorMini): any {
    let response: Author = null;
    if (authorMini != null) {
      response = {
        AuthorId: authorMini.Id,
        Name: authorMini.Name,
        UserId: authorMini.UserId,
        Url: authorMini.UrlSeo,
        UrlPhoto: authorMini.UrlPhoto
      };
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/author.service.ts